var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isshow ||_vm.isShow)?_c('div',{staticClass:"city-campus",on:{"click":_vm.quit}},[_c('div',{staticClass:"citycenter"},_vm._l((_vm.cityList),function(item,index){return _c('div',{key:index,staticClass:"center",on:{"click":function($event){return _vm.showCampusInfo(item.id)}}},[_vm._v(_vm._s(item.name))])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c29cc6c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campus/City.vue
// module id = null
// module chunks = 